import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Typography } from '@mui/material';
import './Main.css'
import { Helmet } from 'react-helmet';

const Main = () => {
  const image = 'https://img.freepik.com/free-photo/goth-students-school-classroom_23-2150576782.jpg?ga=GA1.2.1573239338.1716897012&semt=ais_hybrid'; // Use your image URL here

  return (
    <Container fluid className="p-5 bg-light">
      <Helmet>
        <title>Why Learn at Holy Institute?</title>
        <meta name="description" content="Holy Institute offers excellence in German language education with expert instructors, comprehensive curriculum, and cultural immersion programs." />
        <meta name="keywords" content="Holy Institute, learn German, language education, expert instructors, comprehensive curriculum" />
      </Helmet>
      <Row className="align-items-center mb-4">
        <Col md={6}>
          <Typography variant="h3" style={{fontFamily: 'Roboto Slab, serif'}} className='texthead' gutterBottom>
            Why Learn at Holy Institute?
          </Typography>
          <Typography variant="h5" style={{fontFamily: 'Roboto Slab, serif'}} className='texthead' gutterBottom>
            Experience Excellence in Language Education
          </Typography>
          <Typography variant="body1" style={{fontFamily: 'Roboto Slab, serif'}} paragraph>
            Choosing the right place to learn German is crucial to your success, and Holy Institute stands
            out as a premier choice for language education. Here’s why:
          </Typography>
        </Col>
        <Col md={6} className="text-center">
          <img src={image} style={{borderRadius:'10px'}} alt="Why Learn at Holy Institute?" className="img-fluid cardhover" />
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <Typography variant="h6" style={{fontFamily: 'Roboto Slab, serif'}} className='texthead' gutterBottom>
            Expert Instructors:
          </Typography>
          <Typography variant="body1"  paragraph>
            Our team of highly qualified instructors brings years of experience and a deep passion for teaching.
            They are dedicated to helping you achieve fluency in German, providing personalized attention to
            meet your unique learning needs.
          </Typography>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <Typography variant="h6" style={{fontFamily: 'Roboto Slab, serif'}} className='texthead' gutterBottom>
            Comprehensive Curriculum:
          </Typography>
          <Typography variant="body1"  paragraph>
            At Holy Institute, our curriculum is designed to cover all aspects of language learning—speaking, 
            listening, reading, and writing. Whether you're a beginner or an advanced learner, our structured 
            courses ensure a thorough understanding of the language.
          </Typography>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <Typography variant="h6" style={{fontFamily: 'Roboto Slab, serif'}} className='texthead' gutterBottom>
            Cultural Immersion:
          </Typography>
          <Typography variant="body1" style={{fontFamily: 'Roboto Slab, serif'}} paragraph>
            We believe that language learning goes beyond just words. Our programs include cultural immersion
            experiences that allow you to understand and appreciate the rich traditions and history of German-speaking countries.
          </Typography>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col> 
          <Typography variant="h6" style={{fontFamily: 'Roboto Slab, serif'}} className='texthead' gutterBottom>
            Supportive Community:
          </Typography>
          <Typography variant="body1" style={{fontFamily: 'Roboto Slab, serif'}} paragraph>
            When you join Holy Institute, you become part of a supportive and vibrant community of learners. We foster an encouraging atmosphere where students motivate each other and celebrate their progress together.
          </Typography>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <Typography variant="h6" style={{fontFamily: 'Roboto Slab, serif'}} className='texthead' gutterBottom>
            Proven Success:
          </Typography>
          <Typography variant="body1" style={{fontFamily: 'Roboto Slab, serif'}} paragraph>
            Located in Thrissur, Kerala, our institute offers a peaceful and conducive learning environment
            with modern classrooms and resources that enhance your educational experience.
          </Typography>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <Typography variant="h6" style={{fontFamily: 'Roboto Slab, serif'}} className='texthead' gutterBottom>
            Flexible Learning Options:
          </Typography>
          <Typography variant="body1" style={{fontFamily: 'Roboto Slab, serif'}} paragraph>
            We understand that everyone’s schedule is different. That’s why we offer flexible class timings, including weekend and evening
            courses, to accommodate your lifestyle.
          </Typography>
        </Col>
      </Row>

      <Row>
        <Col>
          <span className='texthead' style={{fontFamily: 'Roboto Slab, serif',fontSize:'10px'}}>
          By choosing Holy Institute, you're not just enrolling in a language course—you’re joining
          a community dedicated to your growth and success.
          </span>
         
        </Col>
      </Row>
    </Container>
  );
};

export default Main;
